module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-add-driver-license"
  }, [_c('label', [_vm._v("Document Type"), _c('selectize-document-type', {
    on: {
      "optionSelected": _vm.selectDocType
    }
  })], 1), (_vm.documentType) ? _c('smart-edit', {
    attrs: {
      "options": _vm.options,
      "value": _vm.document
    },
    on: {
      "input": _vm.updateFields
    }
  }) : _vm._e(), (_vm.documentType) ? _c('div', {
    staticClass: "attachments"
  }, _vm._l((_vm.documentType.attachment_views), function(attachment, index) {
    return _c('div', {
      staticClass: "upload"
    }, [_c('label', [_vm._v("Upload " + _vm._s(attachment))]), _c('dropzone', {
      attrs: {
        "id": '#myVueDropzone' + index,
        "url": _vm.dropzoneUrl
      },
      on: {
        "vdropzone-success": function (file, response) {
          _vm.uploaded(file, response, attachment)
        }
      }
    })], 1)
  }), 0) : _vm._e(), _c('button', {
    staticClass: "button expanded",
    on: {
      "click": _vm.create
    }
  }, [_vm._v("Save and Submit")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-60a791bd!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/smartedits/DriverLicenseCreate.vue
// module id = 2531
// module chunks = 1